import solicitacoesRoutes from './solicitacoes/rotas.js';
import solicitacoesRotasDispensaInexigibilidade from './solicitacoes/dispensaouinexigibilidade/rotas';

const catalogoRoute = {
    path: 'catalogo',
    name: 'Licitacoes_Catalogo',
    component: () => import('./catalogo/Catalogo.vue'),
};

const routes = {
    path: 'licitacoes',
    name: 'Licitacoes',
    component: () => import('./Licitacao.vue'),
    children: [...solicitacoesRoutes, ...solicitacoesRotasDispensaInexigibilidade, catalogoRoute],
    meta: {
        rules: ['LICITACOES-00'],
    },
};

export default routes;
